import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class registroVentaSireService {

    /******* QUERIES ******/

    async listarSeries() {
        const response = await axios
            .get(`${ERP}ventas/registro-venta-sire/series`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async paginacion(filter) {

        const response = await axios
            .get(`${ERP}ventas/registro-venta-sire/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async paginacionSire(filter) {

        const response = await axios
            .get(`${ERP}ventas/registro-venta-sire/paginacion/sire?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    
    async paginacionSireAnexo5(filter) {
        const response = await axios
            .get(`${ERP}ventas/registro-venta-sire/paginacion/sire-anexo5?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async excel(filter) {
        const response = await axios
            .get(`${ERP}ventas/registro-venta-sire/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}ventas/registro-venta-sire/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async sire(filter) {
        const response = await axios
            .get(`${ERP}ventas/registro-venta-sire/sire?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async sireAnexo5(filter) {
        const response = await axios
            .get(`${ERP}ventas/registro-venta-sire/sire-anexo5?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async sireSunat(filter) {
        const response = await axios
            .get(`${ERP}ventas/registro-venta-sire/sire/sunat?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async consulta_sire(data) {
        const response = await axios
            .post(`${ERP}ventas/registro-venta-sire`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

}

export default new registroVentaSireService();